import styles from './ClearAllButton.module.css'
import classNames from "classnames"

interface ClearAllButtonProps {
    className?: string
    onClick: (event: any) => void
}

export const ClearAllButton = (props: ClearAllButtonProps): JSX.Element => {
    const {
        className,
        onClick
    } = props

    const clearAllButtonClasses = classNames(styles.ClearAllButton, className)
    const handleButtonClick = (event: any) => {
        onClick?.(event)
    }

    return (
        <button
            className={clearAllButtonClasses}
            onClick={handleButtonClick}
        >
            <span className={styles.ClearAllButton__Caption}>Clear all</span>
        </button>
    )
}